import { EngagementTemplate } from '../../data/types';
import { useAppDispatch } from '../hooks';
import { addOrReplaceEngagementTemplateAction, deleteEngagementTemplateAction, setEngagementTemplatesAction } from '../reducers/engagementTemplateReducer';

export const useEngagementTemplateActions = () => {

    const dispatch = useAppDispatch();

    const addOrReplaceEngagementTemplate = (engageTemplate: EngagementTemplate) => {
        dispatch(addOrReplaceEngagementTemplateAction(engageTemplate));
    }

    const setEngagementTemplates = (engageTemplates: EngagementTemplate[]) => {
        dispatch(setEngagementTemplatesAction(engageTemplates));
    }

    const removeEngagementTemplate = (engageTemplate: EngagementTemplate) => {
        dispatch(deleteEngagementTemplateAction(engageTemplate));
    }

    return { addOrReplaceEngagementTemplate, setEngagementTemplates, removeEngagementTemplate };
}
